import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {IconArrowBack} from "../../../../../icons/IconArrowBack";
import {RegularCopyAlt} from "../../../../../icons/RegularCopyAlt";
import useDynamicColors from "../../../../../hooks/useDynamicColors";

import "./style.css";

export const CardDetailsVisaMobile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const colors = useDynamicColors();

  const styles = {
    telefono: {
      fontFamily: "Open Sans, sans-serif",
      marginTop: "30px",
      backgroundColor: "#f1f1f1",
      display: "flex",
      borderRadius: "50px",
      border: "15px solid #000000",
      flexDirection: "row",
      justifyContent: "center",
      width: "100%",
    },
    container: {
      display: "flex",
      alignItems: "center",
      margin: "16px 0 8px 0",
      flexDirection: "column",
      padding: "16px",
      height: "100%",
      boxSizing: "border-box",
    },
    arrow: {
      fontSize: "26px",
      marginLeft: "8px",
    },
    lines: {
      display: "flex",
      flexDirection: "column",
      marginRight: "8px",
    },
    lineBlue: {
      width: "40px",
      height: "4px",
      backgroundColor: colors.primario,
      marginBottom: "4px",
    },
    lineYellow: {
      width: "40px",
      height: "4px",
      backgroundColor: colors.secundario,
    },
    title: {
      fontWeight: "bold",
      fontSize: "14px",
    },
    page: {
      fontFamily: "Open Sans, sans-serif",
      display: "flex",
      alignItems: "center",
      justifyContent: "start",
      borderRadius: "30px",
      flexDirection: "column",
      position: "relative",
      backgroundColor: "#ffffff",
      width: "375px",
      height: "812px",
      overflow: "hidden",
      boxShadow: "0 0 20px rgba(0,0,0,0.1)",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "16px",
      width:'100%',
      paddingLeft:2,
      paddingRight:2
    },
    balance: {
      marginTop: "60px",
      color: "#333",
      borderRadius: "12px",
      padding: "16px",
      textAlign: "center",
      marginBottom: "16px",
    },
    balanceCard: {
      display: "flex",
      background: "linear-gradient(90deg, #c49d14, #d6c37f)",
      color: "white",
      borderRadius: "12px 12px 0px 0px",
      padding: "16px",
      justifyContent: "space-between",
      textAlign: "center",
      height: "70px",
      marginBottom: "16px",
    },
    balanceText: {
      color:'#FFFFFF',
      fontSize: "24px",
      fontWeight: "bold",
    },
    actionButtons: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "16px",
    },
    actionButton: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      width: "190px",
      margin: "0 4px",
      padding: "12px",
      backgroundColor: "#f1f1f1",
      border: "none",
      fontWeight: "500",
      cursor: "pointer",
    },

    actionButton2: {
      color: "#ffffff",
      marginTop: 9,
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      width: "90%",
      gap: 8,
      padding: "8px",
      backgroundColor: "#000000",
      border: "none",
      borderRadius: 50,
      fontWeight: "500",

      cursor: "pointer",
    },
    avatarRow: {
      marginTop: "10px",
      display: "flex",
      alignItems: "center",
      gap: "29px",
      marginBottom: "16px",
    },
    avatar: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      fontSize: "12px",
    },
    avatarImg: {
      width: "60px",
      height: "60px",
      border: `1px solid #f7f7f7`,
      objectFit: "cover",
    },
    promoCard: {
      display: "flex",
      alignItems: "center",

      borderRadius: "12px",
      padding: "12px",
    },
    promoImg: {
      width: "60px",
      height: "60px",
      marginRight: "12px",
    },
    bottomNav: {
      display: "flex",
      width: "365px",
      justifyContent: "space-around",
      borderTop: "1px solid #f7f7f7",
      paddingTop: "8px",
      marginLeft: "-15px",
      marginTop: "-5px",
    },
    navItem: {
      width: "70px",
      alignItems: "center",
      gap: 6,
      display: "flex",
      justifyContent: "space-between",
      fontSize: "14px",
      color: "#333",
    },
  };

  const handleButtonBack = () => {
    const currentParams = location.search;
    navigate(`/vxlab-landing-visa-mobile${currentParams}`);
  };

  const handleButtonRestart = () => {
    const currentParams = location.search;
    navigate(`/vxlab-onboarding_register-visa-mobile${currentParams}`);
  };

  return (
      <div className="visa-card-details">
        <div style={styles.page}>
          <div style={{...styles.header, paddingLeft: 2, paddingRight: 2}}>

            {colors.url_logo !== "" ? (
                <img className="inicio-de-sesion-de-2" src={colors.url_logo}
                     style={{height: 50, maxWidth: 100, objectFit:'contain'}}/>) : (<></>)}

            <div
                style={{
                  display: "flex",
                  gap: 8,
                  justifyItems: "center",
                  placeItems: "center",
                }}
            >
              <div>2,015 pts</div>
              <img
                  src="https://randomuser.me/api/portraits/men/75.jpg"
                  alt="User"
                  style={{...styles.avatarImg, borderRadius: 50}}
              />
            </div>
          </div>
          <div className="frame-45">
            <div className="frame-46">
              <div className="overlap-10">
                <div
                    className="group-8"
                    style={{
                      width: 350,
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      borderRadius: 29,
                      backgroundSize: "contain",
                      background: colors.url_card ? `url(${colors.url_card})` : "linear-gradient(90deg, #c49d14, #d6c37f)",
                      marginLeft: 10,
                    }}
                >
                  <div className="overlap-11">

                    <div style={{
                      ...styles.container,
                      flexDirection: "row",
                      width: '100%',
                      justifyContent: 'space-between',
                      paddingTop: 0,
                      paddingBottom: 0,
                    }}>

                      <svg
                          width={63}
                          height={19}
                          viewBox="0 0 63 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M36.4625 15.0292C34.5008 15.0292 33.4252 14.7603 31.7734 14.0817L31.1614 13.8025L30.4674 17.836C31.6607 18.3277 33.8119 18.7502 36.0374 18.7835C41.2642 18.7835 44.6805 16.3583 44.7215 12.6271C44.7624 10.5757 43.4154 9.0187 40.5702 7.73568C38.8441 6.90338 37.7686 6.3451 37.7686 5.49999C37.7686 4.7522 38.6879 3.95575 40.6086 3.95575C42.2604 3.93014 43.4154 4.28099 44.3348 4.64464L44.7957 4.84951L45.4897 0.951782L45.3694 0.977392C44.3783 0.608619 42.8341 0.216797 40.9134 0.216797C35.9964 0.216797 32.5263 2.65992 32.5007 6.16071C32.47 8.73444 34.9695 10.1839 36.8569 11.047C38.7955 11.9305 39.4434 12.4862 39.4383 13.2801C39.4255 14.4863 37.8889 15.0292 36.4625 15.0292ZM58.1305 0.547156H54.2891C53.0931 0.547156 52.1994 0.867272 51.6744 2.04018L44.2861 18.5325H49.513L50.5578 15.8333L56.9345 15.8385C57.0907 16.4684 57.5491 18.5325 57.5491 18.5325H62.1562L58.1305 0.547156ZM51.9894 12.143L53.9715 7.11593C53.9459 7.16715 54.3813 6.0762 54.6322 5.40011L54.9728 6.95203L56.1227 12.143H51.9894Z"
                            fill="white"
                        />
                        <path
                            d="M22.3185 18.3891H27.297L30.4085 0.396084H25.4326V0.390963L22.3185 18.3891Z"
                            fill="white"
                        />
                        <path
                            d="M13.3015 12.8114L12.7842 10.312V10.3196L11.0377 2.05808C10.738 0.913345 9.86219 0.575301 8.77636 0.534326H0.758115L0.694092 0.913343C2.49954 1.3359 4.12573 1.94796 5.58033 2.69831C5.84154 2.85965 5.95166 3.03635 6.0413 3.29757L10.3436 18.5069H15.6038L23.4428 0.547131H18.1698L13.3015 12.8114Z"
                            fill="white"
                        />
                      </svg>
                      <span style={{color:'white'}}> ****9821</span>
                    </div>

                    <div style={{
                      ...styles.container,
                      flexDirection: "row",
                      width: '100%',
                      justifyContent: 'flex-start',
                      paddingTop: 0,
                      paddingBottom: 0,
                      marginTop: 1,
                      marginBottom: 1,
                    }}>
                      <div style={{...styles.balanceText, margin: 0, padding: 0}}>$ 6,256.49 USD</div>
                    </div>

                    <div style={{
                      ...styles.container,
                      flexDirection: "column",
                      width: '100%',
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start',
                      paddingTop: 0,
                      paddingBottom: 0,
                      marginTop: 1,
                      marginBottom: 1,
                    }}>
                      <div style={{...styles.balanceText, margin: 0, padding: 0, fontSize: 12, fontWeight: 'bold'}}>Card
                        Holder
                      </div>
                      <div style={{...styles.balanceText, margin: 0, padding: 0, fontSize: 12}}>Jhon Doe</div>

                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="botonera-2">
              <div className="frame-51">
                <svg
                    width={25}
                    height={25}
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                      x={2.55371}
                      y={4.59131}
                      width={19.8947}
                      height={15.3311}
                      rx={2}
                      stroke={colors.cuaternario}
                      strokeWidth={1.5}
                  />
                  <path
                      d="M5.36719 8.83466H19.5219"
                      stroke={colors.cuaternario}
                      strokeWidth={1.5}
                  />
                </svg>

                <div className="text-wrapper-53-quinto">Pay</div>
              </div>
              {" "}
              <div className="frame-51">
                <svg
                    width={25}
                    height={25}
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.66145 1.25684L17.3385 1.25684C17.8657 1.25682 18.3205 1.2568 18.695 1.28741C19.0904 1.31971 19.4836 1.39103 19.862 1.58382C20.4265 1.87144 20.8854 2.33038 21.173 2.89487C21.3658 3.27325 21.4371 3.66647 21.4694 4.06181C21.5 4.43638 21.5 4.89113 21.5 5.41827V19.0954C21.5 19.6225 21.5 20.0773 21.4694 20.4519C21.4371 20.8472 21.3658 21.2404 21.173 21.6188C20.8854 22.1833 20.4265 22.6422 19.862 22.9299C19.4836 23.1227 19.0904 23.194 18.695 23.2263C18.3205 23.2569 17.8657 23.2569 17.3386 23.2568H10.5C10.1822 23.2568 9.89902 23.1086 9.71585 22.8775C9.68378 22.8516 9.65251 22.8236 9.62218 22.7932L3.96361 17.1347C3.93328 17.1043 3.90522 17.0731 3.87937 17.041C3.64825 16.8578 3.5 16.5746 3.5 16.2568L3.5 5.41829C3.49998 4.89115 3.49997 4.43638 3.53057 4.06181C3.56287 3.66646 3.63419 3.27325 3.82698 2.89487C4.1146 2.33038 4.57354 1.87144 5.13803 1.58382C5.51641 1.39102 5.90963 1.31971 6.30497 1.28741C6.67954 1.2568 7.13431 1.25682 7.66145 1.25684ZM6.91422 17.2568L9.5 19.8426L9.5 17.2568H6.91422ZM11.5 21.2568V17.2568C11.5 16.1523 10.6046 15.2568 9.5 15.2568H5.5L5.5 5.45684C5.5 4.88028 5.50078 4.50801 5.52393 4.22467C5.54612 3.95301 5.5838 3.85229 5.609 3.80285C5.70487 3.61469 5.85785 3.4617 6.04601 3.36583C6.09546 3.34064 6.19617 3.30296 6.46784 3.28077C6.75117 3.25762 7.12345 3.25684 7.7 3.25684L17.3 3.25684C17.8766 3.25684 18.2488 3.25762 18.5322 3.28077C18.8038 3.30296 18.9045 3.34064 18.954 3.36583C19.1422 3.46171 19.2951 3.61469 19.391 3.80285C19.4162 3.85229 19.4539 3.95301 19.4761 4.22467C19.4992 4.50801 19.5 4.88028 19.5 5.45684V19.0568C19.5 19.6334 19.4992 20.0057 19.4761 20.289C19.4539 20.5607 19.4162 20.6614 19.391 20.7108C19.2951 20.899 19.1422 21.052 18.954 21.1478C18.9045 21.173 18.8038 21.2107 18.5322 21.2329C18.2488 21.2561 17.8766 21.2568 17.3 21.2568H11.5ZM7.5 8.25684C7.5 7.70455 7.94772 7.25684 8.5 7.25684H16.5C17.0523 7.25684 17.5 7.70455 17.5 8.25684C17.5 8.80912 17.0523 9.25684 16.5 9.25684H8.5C7.94772 9.25684 7.5 8.80912 7.5 8.25684ZM7.5 12.2568C7.5 11.7046 7.94772 11.2568 8.5 11.2568H16.5C17.0523 11.2568 17.5 11.7046 17.5 12.2568C17.5 12.8091 17.0523 13.2568 16.5 13.2568H8.5C7.94772 13.2568 7.5 12.8091 7.5 12.2568ZM13.5 16.2568C13.5 15.7046 13.9477 15.2568 14.5 15.2568H16.5C17.0523 15.2568 17.5 15.7046 17.5 16.2568C17.5 16.8091 17.0523 17.2568 16.5 17.2568H14.5C13.9477 17.2568 13.5 16.8091 13.5 16.2568Z"
                      fill={colors.cuaternario}
                  />
                </svg>
                <div className="text-wrapper-53-quinto">Details</div>
              </div>
              <div className="frame-51">
                <svg
                    width={25}
                    height={25}
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_271_6272)">
                    <path
                        d="M19.7254 15.1564C19.3593 14.7903 18.7657 14.7903 18.3996 15.1564L18.125 15.431L17.8504 15.1564C17.4843 14.7903 16.8907 14.7903 16.5246 15.1564C16.1585 15.5225 16.1585 16.1162 16.5246 16.4823L16.7992 16.7568L16.5246 17.0314C16.1585 17.3976 16.1585 17.9912 16.5246 18.3573C16.8907 18.7234 17.4843 18.7234 17.8504 18.3573L18.125 18.0827L18.3996 18.3573C18.7657 18.7234 19.3593 18.7234 19.7254 18.3573C20.0916 17.9911 20.0916 17.3975 19.7254 17.0314L19.4508 16.7568L19.7254 16.4823C20.0916 16.1162 20.0916 15.5225 19.7254 15.1564Z"
                        fill={colors.cuaternario}
                    />
                    <path
                        d="M14.1004 15.1564C13.7343 14.7903 13.1407 14.7903 12.7746 15.1564L12.5 15.431L12.2254 15.1564C11.8593 14.7903 11.2657 14.7903 10.8996 15.1564C10.5335 15.5225 10.5335 16.1162 10.8996 16.4823L11.1742 16.7568L10.8996 17.0314C10.5335 17.3976 10.5335 17.9912 10.8996 18.3573C11.2657 18.7234 11.8593 18.7234 12.2254 18.3573L12.5 18.0827L12.7746 18.3573C13.1407 18.7234 13.7343 18.7234 14.1004 18.3573C14.4666 17.9911 14.4666 17.3975 14.1004 17.0314L13.8258 16.7568L14.1004 16.4823C14.4666 16.1162 14.4666 15.5225 14.1004 15.1564Z"
                        fill={colors.cuaternario}
                    />
                    <path
                        d="M8.47542 15.1564C8.10928 14.7903 7.5157 14.7903 7.14961 15.1564L6.87501 15.431L6.60042 15.1564C6.23428 14.7903 5.6407 14.7903 5.27461 15.1564C4.90846 15.5225 4.90846 16.1162 5.27461 16.4823L5.5492 16.7568L5.27461 17.0314C4.90846 17.3976 4.90846 17.9912 5.27461 18.3573C5.64075 18.7234 6.23432 18.7234 6.60042 18.3573L6.87501 18.0827L7.14961 18.3573C7.51575 18.7234 8.10932 18.7234 8.47542 18.3573C8.84156 17.9911 8.84156 17.3975 8.47542 17.0314L8.20082 16.7568L8.47542 16.4823C8.84156 16.1162 8.84156 15.5225 8.47542 15.1564Z"
                        fill={colors.cuaternario}
                    />
                    <path
                        d="M20.9375 9.25684H19.0625V6.81934C19.0625 3.20077 16.1186 0.256836 12.5 0.256836C8.88144 0.256836 5.9375 3.20077 5.9375 6.81934V9.25684H4.0625C2.51169 9.25684 1.25 10.5185 1.25 12.0693V21.4443C1.25 22.9951 2.51169 24.2568 4.0625 24.2568H20.9375C22.4883 24.2568 23.75 22.9951 23.75 21.4443V12.0693C23.75 10.5185 22.4883 9.25684 20.9375 9.25684ZM7.8125 6.81934C7.8125 4.23465 9.91531 2.13184 12.5 2.13184C15.0847 2.13184 17.1875 4.23465 17.1875 6.81934V9.25684H7.8125V6.81934ZM21.875 21.4443C21.875 21.9613 21.4544 22.3818 20.9375 22.3818H4.0625C3.54556 22.3818 3.125 21.9613 3.125 21.4443V12.0693C3.125 11.5524 3.54556 11.1318 4.0625 11.1318H20.9375C21.4544 11.1318 21.875 11.5524 21.875 12.0693V21.4443Z"
                        fill={colors.cuaternario}
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_271_6272">
                      <rect
                          width={24}
                          height={24}
                          fill="white"
                          transform="translate(0.5 0.256836)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <div className="text-wrapper-53-quinto">PIN</div>
              </div>
              <div className="frame-51">
                <svg
                    width={21}
                    height={21}
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      d="M20.6477 8.8976L20.1453 7.35133L17.0636 8.35261L18.3963 5.73715L16.9477 4.99899L14.8769 9.06317L11.313 10.2211V6.47389L14.5384 3.24856L13.3888 2.0989L11.313 4.17456V0.934326H9.68715V4.17456L7.61148 2.0989L6.46182 3.24856L9.68715 6.47389V10.2211L6.12341 9.06317L4.05257 4.99899L2.60391 5.73715L3.93659 8.35266L0.854884 7.35133L0.352539 8.89766L3.43414 9.89893L0.818627 11.2316L1.55673 12.6802L5.62096 10.6094L9.18469 11.7674L6.98215 14.7989L2.47703 15.5125L2.73138 17.1184L5.63061 16.6592L3.72609 19.2806L5.04149 20.2362L6.94606 17.6149L7.40526 20.5141L9.0111 20.2598L8.29755 15.7546L10.5001 12.7231L12.7027 15.7546L11.9891 20.2598L13.595 20.5141L14.0542 17.6148L15.9588 20.2362L17.2741 19.2805L15.3696 16.6592L18.2689 17.1184L18.5232 15.5125L14.018 14.7989L11.8154 11.7674L15.3793 10.6094L19.4435 12.6802L20.1816 11.2316L17.566 9.89893L20.6477 8.8976Z"
                      fill={colors.cuaternario}
                  />
                </svg>

                <div className="text-wrapper-53-quinto">Freezer</div>
              </div>
              <div className="frame-51">
                <svg
                    width={25}
                    height={25}
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M16.5 3.25684C17.0523 3.25684 17.5 3.70455 17.5 4.25684V5.25684L21.5 5.25684C22.0523 5.25684 22.5 5.70455 22.5 6.25684C22.5 6.80912 22.0523 7.25684 21.5 7.25684L17.5 7.25684V8.25684C17.5 8.80912 17.0523 9.25684 16.5 9.25684C15.9477 9.25684 15.5 8.80912 15.5 8.25684V4.25684C15.5 3.70455 15.9477 3.25684 16.5 3.25684ZM2.5 6.25684C2.5 5.70455 2.94772 5.25684 3.5 5.25684L12.5 5.25684C13.0523 5.25684 13.5 5.70455 13.5 6.25684C13.5 6.80912 13.0523 7.25684 12.5 7.25684L3.5 7.25684C2.94772 7.25684 2.5 6.80912 2.5 6.25684ZM8.5 9.25684C9.05228 9.25684 9.5 9.70455 9.5 10.2568V14.2568C9.5 14.8091 9.05228 15.2568 8.5 15.2568C7.94772 15.2568 7.5 14.8091 7.5 14.2568V13.2568H3.5C2.94772 13.2568 2.5 12.8091 2.5 12.2568C2.5 11.7046 2.94772 11.2568 3.5 11.2568H7.5V10.2568C7.5 9.70455 7.94772 9.25684 8.5 9.25684ZM11.5 12.2568C11.5 11.7046 11.9477 11.2568 12.5 11.2568H21.5C22.0523 11.2568 22.5 11.7046 22.5 12.2568C22.5 12.8091 22.0523 13.2568 21.5 13.2568H12.5C11.9477 13.2568 11.5 12.8091 11.5 12.2568ZM16.5 15.2568C17.0523 15.2568 17.5 15.7046 17.5 16.2568V17.2568H21.5C22.0523 17.2568 22.5 17.7046 22.5 18.2568C22.5 18.8091 22.0523 19.2568 21.5 19.2568H17.5V20.2568C17.5 20.8091 17.0523 21.2568 16.5 21.2568C15.9477 21.2568 15.5 20.8091 15.5 20.2568V16.2568C15.5 15.7046 15.9477 15.2568 16.5 15.2568ZM2.5 18.2568C2.5 17.7046 2.94772 17.2568 3.5 17.2568L12.5 17.2568C13.0523 17.2568 13.5 17.7046 13.5 18.2568C13.5 18.8091 13.0523 19.2568 12.5 19.2568H3.5C2.94772 19.2568 2.5 18.8091 2.5 18.2568Z"
                      fill={colors.cuaternario}
                  />
                </svg>
                <div className="text-wrapper-53-quinto">Manage</div>
              </div>
            </div>

            <div className="frame-55" style={{marginTop: 15}}>
              <div className="tarjtetas-2">
                <div className="title-4">Activity</div>

                <div className="frame-56">
                  <div className="btn-text-link-2">
                    <div className="text-wrapper-54">See all</div>

                    <img
                        className="img-3"
                        alt="Btn icon chevron"
                        src="/img/btn-icon-chevron-4.svg"
                    />
                  </div>
                </div>
              </div>

              <button style={styles.actionButton2}>
                <img
                    className="img-3"
                    alt="Btn icon chevron"
                    src="/img/visawallet.png"
                />
                Add to Google Wallet
              </button>

              <div className="frame-57" style={{marginTop: -5}}>
                <div className="movements-3">
                  <div className="frame-58">
                    <img className="img-3" alt="Dinner" src="/img/dinner-1.svg"/>

                    <div className="frame-50">
                      <div className="text-wrapper-55">Starbucks coffee time</div>

                      <img
                          className="img-3"
                          alt="Btn icon chevron"
                          src="/img/btn-icon-chevron-5.svg"
                      />
                    </div>
                  </div>

                  <div className="frame-59">
                    <div className="date-3">11/06/22</div>

                    <div className="amount-4">- $25.11</div>
                  </div>
                </div>

                <div className="movements-3">
                  <div className="frame-58">
                    <img
                        className="shopping-bag-2"
                        alt="Shopping bag"
                        src="/img/shopping-bag-1.svg"
                    />

                    <div className="frame-50">
                      <div className="text-wrapper-55">New gymn shoes</div>

                      <img
                          className="img-3"
                          alt="Btn icon chevron"
                          src="/img/btn-icon-chevron-5.svg"
                      />
                    </div>
                  </div>

                  <div className="frame-59">
                    <div className="date-3">11/06/22</div>

                    <div className="amount-4">- $158.68</div>
                  </div>
                </div>

                <div className="movements-3">
                  <div className="frame-58">
                    <img
                        className="img-3"
                        alt="Credit card"
                        src="/img/credit-card-1.svg"
                    />

                    <div className="frame-60">
                      <div className="text-wrapper-55">Card payment</div>

                      <img
                          className="img-3"
                          alt="Btn icon chevron"
                          src="/img/btn-icon-chevron-5.svg"
                      />
                    </div>
                  </div>

                  <div className="frame-59">
                    <div className="date-3">11/06/22</div>

                    <div className="amount-5">$950.23</div>
                  </div>
                </div>
              </div>


              <div style={styles.bottomNav}>
                <div style={styles.navItem} onClick={handleButtonBack}>
                  <svg
                      width={23}
                      height={26}
                      viewBox="0 0 23 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M0.0860297 23.9238H21.5216V8.9281L11.4826 1.79596L1.3024 8.9281V19.973"
                        stroke={colors.primario}
                        strokeWidth={2.5}
                        strokeLinejoin="round"
                    />
                  </svg>
                  Home
                </div>
                <div style={styles.navItem}>
                  {" "}
                  <img src={'./img/visa_wallet.png'} style={{height: 30, width: 30}}
                       alt={''}/>{" "}
                  Wallet
                </div>
                <div style={styles.navItem} onClick={handleButtonRestart}>
                  {" "}
                  <img src={'./img/visa_more.png'} style={{height: 30, width: 30}}
                       alt={''}/>{" "}
                  More
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
  );
};
